// src/vo/CoChu.js
import React, { useEffect, useRef, useState } from "react";

// ============================================================
// 🔠 NÚM CHỈNH CỠ CHỮ
// ------------------------------------------------------------
// Điểm 2 mục 9b, chủ nhà nêu 05/09/2026 sau khi cài app lên iPhone:
// *"nên có một núm chỉnh cỡ chữ trong app, đừng bắt người dùng tự phóng to
// mỗi lần mở."*
//
// Cách chạy: đặt thuộc tính `data-co-chu` lên thẻ <html>. App.css định nghĩa
// biến `--ti-le-chu` theo thuộc tính đó, và MỌI `font-size` trong App.css đều
// nhân với biến này. Đổi một thuộc tính là cả app đổi theo.
//
// ⚠️ CHỈ CÓ BA MỨC, KHÔNG CÓ MỨC NHỎ HƠN CỠ CHUẨN. Hai lý do:
//   1. Ô nhập trên điện thoại phải đủ 16px. Dưới đó iPhone tự phóng to cả
//      trang mỗi lần bấm vào ô — trang nhảy giật sau mỗi lần gõ.
//   2. Chưa ai xin chữ nhỏ hơn. Cả nhà kêu chữ NHỎ QUÁ.
//
// ⚠️ Lựa chọn lưu trong localStorage của TỪNG MÁY, không lưu lên máy chủ.
// Cố ý: đây là chuyện của đôi mắt người đang cầm máy, không phải thuộc tính
// của tài khoản. Ba mở trên máy tính muốn cỡ vừa, mở trên điện thoại muốn cỡ
// lớn — hai máy hai lựa chọn, không cái nào đúng hơn cái nào.
//
// ============================================================
// 🔄 BẢN 2 — GỌN LẠI THÀNH MỘT NÚT (08/09/2026)
// ------------------------------------------------------------
// Bản đầu bày thẳng ba nút [Vừa][Lớn][Rất lớn] kèm chữ "Cỡ chữ" trên đầu
// trang. Chủ nhà xem trên máy thật rồi nói:
//
//   "Việc điều chỉnh cỡ chữ rất tốt nhưng chiếm chỗ như vậy là không được.
//    (sau này nếu được "núp" trong dấu ... được không?)"
//
// Và câu quan trọng hơn đi kèm: *"chúng ta xây dựng app không phải chỉ mình
// tôi xài."* Đúng — bốn phần năm số người mở app sẽ không bao giờ đụng tới
// cái núm này, mà nó chiếm bốn ô trên đầu mọi trang của họ.
//
// ⚠️ NHƯNG PHẢI GIỮ BẰNG ĐƯỢC: MỘT LẦN BẤM LÀ RA BA MỨC.
// Chôn nó dưới menu "..." rồi còn phải tìm tiếp trong danh sách là ba lần
// bấm. Người cần cái núm này nhất chính là người ĐANG KHÔNG ĐỌC ĐƯỢC CHỮ —
// bắt họ dò qua ba lớp là hỏng đúng mục đích của nó.
//
// Nên: một nút `Aa`, bấm một lần hiện thẳng ba mức. Chiếm khoảng một phần
// tư chỗ cũ, vẫn một lần bấm.
// ============================================================

const KHOA = "quan-gia-co-chu";
const MAC_DINH = "vua";

export const CAC_MUC = [
  { ma: "vua", nhan: "Vừa" },
  { ma: "lon", nhan: "Lớn" },
  { ma: "rat-lon", nhan: "Rất lớn" },
];

const hopLe = (ma) => CAC_MUC.some((m) => m.ma === ma);

export function docCoChu() {
  try {
    const ma = window.localStorage.getItem(KHOA);
    return hopLe(ma) ? ma : MAC_DINH;
  } catch (e) {
    return MAC_DINH;
  }
}

/**
 * Đặt cỡ chữ lên thẻ <html>. Gọi một lần lúc app khởi động (index.js) để
 * trang không hiện cỡ chuẩn rồi mới nhảy sang cỡ đã chọn.
 */
export function apDungCoChu(ma) {
  const chon = hopLe(ma) ? ma : MAC_DINH;
  document.documentElement.setAttribute("data-co-chu", chon);
  try {
    window.localStorage.setItem(KHOA, chon);
  } catch (e) {
    // Không lưu được thì thôi — cỡ chữ vẫn đúng cho tới khi đóng app.
  }
  return chon;
}

export default function NumCoChu() {
  const [dangChon, setDangChon] = useState(docCoChu);
  const [mo, setMo] = useState(false);
  const khung = useRef(null);

  // Bấm ra ngoài hoặc bấm Esc thì đóng bảng chọn.
  // Không có phần này thì trên điện thoại bảng chọn mở ra rồi không có cách
  // nào đóng lại ngoài việc chọn một mức — mà người ta có thể chỉ muốn xem
  // đang ở mức nào rồi thôi.
  useEffect(() => {
    if (!mo) return undefined;
    const bamNgoai = (e) => {
      if (khung.current && !khung.current.contains(e.target)) setMo(false);
    };
    const bamPhim = (e) => {
      if (e.key === "Escape") setMo(false);
    };
    document.addEventListener("mousedown", bamNgoai);
    document.addEventListener("touchstart", bamNgoai);
    document.addEventListener("keydown", bamPhim);
    return () => {
      document.removeEventListener("mousedown", bamNgoai);
      document.removeEventListener("touchstart", bamNgoai);
      document.removeEventListener("keydown", bamPhim);
    };
  }, [mo]);

  const chon = (ma) => {
    setDangChon(apDungCoChu(ma));
    setMo(false);
  };

  const tenDangChon = CAC_MUC.find((m) => m.ma === dangChon)?.nhan || "";

  return (
    <div className="co-chu" ref={khung}>
      <button
        type="button"
        className={mo ? "co-chu-nut dang-mo" : "co-chu-nut"}
        onClick={() => setMo(!mo)}
        aria-expanded={mo}
        aria-haspopup="true"
        title={`Chỉnh cỡ chữ — đang dùng cỡ ${tenDangChon}`}
      >
        Aa
      </button>

      {mo && (
        <div className="co-chu-bang" role="group" aria-label="Chọn cỡ chữ">
          <div className="co-chu-tieu-de">Cỡ chữ</div>
          {CAC_MUC.map((m) => (
            <button
              key={m.ma}
              type="button"
              onClick={() => chon(m.ma)}
              className={m.ma === dangChon ? "co-chu-mot dang-chon" : "co-chu-mot"}
              aria-pressed={m.ma === dangChon}
            >
              {m.nhan}
              {m.ma === dangChon && <span className="co-chu-dau"> ✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
